<div class="quick-play-panel">
  <div class="panel-header">
    <h3>Quick Play</h3>
    <button mat-icon-button 
            [matMenuTriggerFor]="menu"
            matTooltip="Quick Play Settings"
            class="settings-button">
      <mat-icon>settings</mat-icon>
    </button>
  </div>

  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="openGenreSelection()">
      <mat-icon>library_music</mat-icon>
      <span>Select Genres</span>
    </button>
    <button mat-menu-item (click)="onCreateNewPlaylist()">
      <mat-icon>add</mat-icon>
      <span>New playlist…</span>
    </button>
  </mat-menu>

  <div class="genre-buttons">
    <button *ngFor="let genre of quickGenres"
            mat-raised-button
            color="accent"
            class="genre-button"
            [disabled]="loading"
            (click)="onQuickPlay(genre)"
            [matTooltip]="'Generate ' + getGenreDisplayName(genre) + ' playlist'">
      <mat-icon class="genre-icon">{{ getGenreIcon(genre) }}</mat-icon>
      <span class="genre-label">{{ getGenreDisplayName(genre) }}</span>
    </button>

    <div *ngIf="quickGenres.length === 0" class="empty-state">
      <p>No genres selected</p>
      <button mat-button color="primary" (click)="openGenreSelection()">
        Select Genres
      </button>
    </div>
  </div>

  <!-- Voice command section -->
  <div class="voice-section" *ngIf="voiceEnabled">
    <mat-divider></mat-divider>
    <div class="voice-header">
      <h4>Voice Commands</h4>
      <button mat-icon-button (click)="showVoiceHelp()" matTooltip="Voice command help">
        <mat-icon>help_outline</mat-icon>
      </button>
    </div>
    <app-voice-speech [disabled]="loading"></app-voice-speech>
  </div>

  <div *ngIf="loading" class="loading-overlay">
    <mat-spinner diameter="30"></mat-spinner>
    <p>Creating playlist...</p>
  </div>
</div>